import { isEmpty } from "lodash";

import { Like } from "../components";
import ThumbNail from "../components/thumbNail/ThumbNail";

import styles from "./config.module.scss";

export const columns = [
  {
    field: "id",
    renderCell: (row) => (
      <ThumbNail
        name={row.title}
        color={row.color}
        imgSrc={row.thumbnail_img}
        hasImage={!isEmpty(row.thumbnail_img)}
      />
    ),
    className: styles.image,
  },
  {
    field: "title",
    headerName: "Song",
  },
  {
    field: "artist_name",
    headerName: "Artist",
  },

  {
    field: "like",
    headerName: "Like",
    renderCell: (row) => <Like row={row} />,
    className: styles.likePageFavorite,
  },
];
